import { createTheme } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#C14A09",
    },
    secondary: {
      main: "#42A74B",
    },
    info: {
      main: "#C14A09",
    },
    success: {
      main: "#C14A09",
    },
    error: {
      main: "#C14A09",
    },
    warning: {
      main: "#C14A09",
    },
  },
});
export default theme;
